/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CornersOut(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674l-40-40A8.00037,8.00037,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48ZM53.65723,162.34326A8.0001,8.0001,0,0,0,40,168v40a8.00039,8.00039,0,0,0,8,8H88a8.00038,8.00038,0,0,0,5.65723-13.65674Zm157.40429-1.73437a8.00026,8.00026,0,0,0-8.71875,1.73437l-40,40A8.00037,8.00037,0,0,0,168,216h40a8.00039,8.00039,0,0,0,8-8V168A8.00065,8.00065,0,0,0,211.06152,160.60889ZM88,40H48a8.00008,8.00008,0,0,0-8,8V88a8.00018,8.00018,0,0,0,13.65723,5.65674l40-40A8.00038,8.00038,0,0,0,88,40Z" />
    </Svg>
  );
}

export default CornersOut;
